import { useAtomValue } from 'jotai';

import { DrawerBody } from '@growtherapy/sprout-ui';

import { scheduledPatientInformationAtom } from '../schedule-preview/state';
import { AppointmentType, RecurringAppointmentGrouping } from '../schedule-preview/types';
import { EditAppointmentFormValues } from './EditAppointmentDrawer';
import { ScheduleAppointmentFormWrapper as ScheduleAppointmentForm } from './ScheduleAppointmentForm';
import { GetSchedulingAlertsQueryData } from './useGetSchedulingAlerts';

interface EditAppointmentDrawerBodyProps {
  formValues: EditAppointmentFormValues;
  onUpdateValues: (values: Partial<EditAppointmentFormValues>) => void;
  appointmentType: AppointmentType;
  recurringAppointmentGrouping?: RecurringAppointmentGrouping | null;
  alertsData?: GetSchedulingAlertsQueryData;
  timeInputErrorMessage?: string;
}

export function EditAppointmentDrawerBody({
  formValues,
  onUpdateValues,
  appointmentType,
  recurringAppointmentGrouping,
  alertsData,
  timeInputErrorMessage,
}: EditAppointmentDrawerBodyProps) {
  return (
    <DrawerBody>
      <ScheduleAppointmentForm
        formValues={formValues}
        onUpdateValues={onUpdateValues}
        appointmentType={appointmentType}
        recurringAppointmentGrouping={recurringAppointmentGrouping}
        alertsData={alertsData}
        timeInputErrorMessage={timeInputErrorMessage}
        isRecurrenceEditable={false}
      />
    </DrawerBody>
  );
}

export function EditAppointmentDrawerBodyWrapper({
  ...props
}: Omit<EditAppointmentDrawerBodyProps, 'appointmentType' | 'recurringGroupingId' | 'conflictMessage'>) {
  const appointmentData = useAtomValue(scheduledPatientInformationAtom);

  if (!appointmentData) {
    return;
  }

  return (
    <EditAppointmentDrawerBody
      {...props}
      appointmentType={appointmentData.appointmentType ?? AppointmentType.FollowUp}
      recurringAppointmentGrouping={appointmentData.recurringAppointmentGrouping}
      alertsData={props.alertsData}
    />
  );
}
